import { z } from 'zod'

import { PermissionType } from '../constants/permission'
import { OrganizationRelationshipKind } from '../constants/organizationRelationshipKind'
import { dbEntitySchema, listQueryZodFields } from './system'

export const organizationRelationshipPermissionSchema = z.object({
  _id: z.string(),
  venue: z.string(),
  name: z.string(),
  value: z.nativeEnum(PermissionType),
})

export const organizationRelationshipSchema = dbEntitySchema.extend({
  parentOrganization: z.string(),
  childOrganization: z.string(),
  kind: z
    .nativeEnum(OrganizationRelationshipKind)
    .optional()
    .nullable()
    .default(OrganizationRelationshipKind.PROMOTER),
  permissions: z
    .array(organizationRelationshipPermissionSchema)
    .optional()
    .nullable(),
  name: z.string().optional().nullable(),
  email: z.string(),
  phone: z.string().optional().nullable(),
  profileImage: z.string().optional().nullable(),
  logo: z.string().optional().nullable(),
})

export const organizationRelationshipPublicPromoterSchema = z.object({
  id: z.string(),
  name: z.string().optional().nullable(),
  profileImage: z.string().optional().nullable(),
  logo: z.string().optional().nullable(),
})

export const organizationRelationshipPublicPromoterResponseSchema = z.object({
  data: organizationRelationshipPublicPromoterSchema,
})

export const organizationRelationshipCreateArgsSchema = z.object({
  parentOrganizationId: z.string(),
  childOrganizationId: z.string().optional(),
  kind: z.nativeEnum(OrganizationRelationshipKind).optional(),
  name: z.string().optional().nullable(),
  firstName: z.string().optional().nullable(),
  lastName: z.string().optional().nullable(),
  email: z.string().email(),
  phone: z.string().optional().nullable(),
  profileImage: z.string().optional().nullable(),
  logo: z.string().optional().nullable(),
  venueIds: z.array(z.string()).optional(),
})

export const organizationRelationshipUpdateByIdArgsSchema = z.object({
  name: z.string().optional().nullable(),
  firstName: z.string().optional().nullable(),
  lastName: z.string().optional().nullable(),
  email: z.string().email().optional().nullable(),
  phone: z.string().optional().nullable(),
  profileImage: z.string().optional().nullable(),
  kind: z.nativeEnum(OrganizationRelationshipKind).optional(),
  logo: z.string().optional().nullable(),
})

export const organizationRelationshipListArgsSchema = z.object({
  parentOrganizationId: z.string().optional(),
  childOrganizationId: z.union([z.string(), z.array(z.string())]).optional(),
  venueId: z.union([z.string(), z.array(z.string())]).optional(),
  kind: z.nativeEnum(OrganizationRelationshipKind).optional(),
  search: z.string().optional(),
  deleted: z.boolean().optional(),
})

export const organizationRelationshipPermissionOptionsSchema = z.object({
  venueId: z.string().optional(),
})

export const organizationRelationshipListQuerySchema = z.object({
  ...listQueryZodFields,
  search: z.string().optional().nullable(),
  venueId: z.string().optional().nullable(),
  venueIds: z
    .union([z.string(), z.array(z.string())])
    .optional()
    .nullable(),
})

export const organizationRelationshipListResponseSchema = z.object({
  data: z.array(organizationRelationshipSchema),
  count: z.number(),
})
